export default __webpack_public_path__ + "static/thumbnail_files-e84da4d13b892f0d2ecf1aa51a6116b5.png";